import { memo } from 'react';
import { Node, NodeProps } from '@xyflow/react';
import { TxCenterMapIcon } from '@icons';
import { RouteNodeType } from '@lp/features/RoutePlanner/types';
import { NodeHandleConnections } from './NodeHandleConnections';

export type TxCenterNodeProps = Node<RouteNodeType['data'], 'txCenterNode'>;

export const TxCenterNode = memo(({ data }: NodeProps<TxCenterNodeProps>) => {
  return (
    <NodeHandleConnections>
      <div className="flex justify-center gap-1 border-1 border-danger-10 items-center bg-danger-10 pl-0 pr-0.5 rounded-sm text-white">
        <TxCenterMapIcon width={16} height={16} />
        <span className="font-mono text-s-sb">{data.title}</span>
      </div>
    </NodeHandleConnections>
  );
});
